import { FAQ, Panel, PanelState, theme, useMediaMin } from '@foradevelopment/fora-ui';
import { EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';

import { useTypedTranslation } from '../../../i18n/i18n';
import { useAppSelector } from '../../../redux/hooks';
import { EditEmploymentPeriodConfirmationDetails } from '../../components/EditEmploymentPeriodConfirmationDetails';

type EditEmploymentPeriodConfirmationPanelProps = {
  panelState: PanelState;
  goBackToEditPanel: () => void;
  employmentPeriodIndex: number;
  employment?: EmploymentViewModelNew;
};

export const EditEmploymentPeriodConfirmationPanel = ({
  panelState,
  goBackToEditPanel,
  employmentPeriodIndex,
  employment,
}: EditEmploymentPeriodConfirmationPanelProps) => {
  const { t } = useTypedTranslation();
  const faqs = useAppSelector(state => state.content.content.faqListEditEmploymentPeriodReceiptStep);
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  const employmentPeriod = employment?.employmentPeriods[employmentPeriodIndex];

  return (
    <Panel
      {...panelState}
      previousPanelName="edit-employment-panel"
      name="panel-confirmation"
      // To prevent the end employment datepicker popup in in the first panel from being behind this panel
      zIndex={-1}
    >
      <Panel.Header>{t('panel.employeeAddedOrUpdated.panelTitle')}</Panel.Header>
      <Panel.Body>
        <Panel.MainSection>
          {employment && employmentPeriod ? (
            <EditEmploymentPeriodConfirmationDetails
              employment={employment}
              employmentPeriod={employmentPeriod}
              resetPanels={goBackToEditPanel}
            />
          ) : null}
        </Panel.MainSection>
        <Panel.AsideSection>
          {faqs.length > 0 && isDesktop && (
            <FAQ testId="test-update-employment-faq" layout="side" questionAnswers={faqs} />
          )}
        </Panel.AsideSection>
        {faqs.length > 0 && !isDesktop && (
          <FAQ testId="test-update-employment-faq" layout="modal" questionAnswers={faqs} />
        )}
      </Panel.Body>
    </Panel>
  );
};
